import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
  errorStack: string;
}

/**
 * Global error boundary that catches unhandled React errors and renders
 * a user-friendly error screen instead of crashing the application.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, errorMessage: '', errorStack: '' };

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      errorMessage: error?.message || 'Невідома помилка',
      errorStack: error?.stack || ''
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary] Uncaught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      const { errorMessage, errorStack } = this.state;
      const copyText = `Помилка: ${errorMessage}\n\n${errorStack}`;

      return (
        <div className="access-denied-container">
          <div className="access-denied-content">
            <div className="warning-icon">⚠</div>
            <h2>Сталася помилка</h2>
            <p>Виникла неочікувана помилка. Будь ласка, оновіть сторінку або зверніться до адміністратора.</p>
            <div style={{ margin: '1rem 0', padding: '0.75rem', background: '#f5f5f5', borderRadius: '4px', textAlign: 'left', fontSize: '0.8rem', color: '#333', wordBreak: 'break-word', maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd' }}>
              <strong>Деталі помилки:</strong><br />
              {errorMessage}
            </div>
            <div className="actions" style={{ gap: '0.5rem', display: 'flex', justifyContent: 'center' }}>
              <button
                className="logout-button"
                style={{ background: '#666' }}
                onClick={() => navigator.clipboard?.writeText(copyText)}
              >
                Копіювати деталі
              </button>
              <button className="logout-button" onClick={() => window.location.reload()}>
                Оновити сторінку
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
